// Account: the sessions list with the shared key (spec 10 § 9); the profile is /me's user (shared/org/me).
import { queryOptions } from '@tanstack/react-query'
import { api } from '../../shared/api/api'
import { keys } from '../../shared/query/keys'

export const sessionsQuery = () =>
  queryOptions({
    queryKey: keys.meSessions(),
    queryFn: async ({ signal }) => (await api.GET('/me/sessions', { signal })).data?.items ?? [],
    staleTime: 15_000,
  })

/** The person's own personal access tokens in one organization (D223). */
export const tokensQuery = (orgId: string) =>
  queryOptions({
    queryKey: keys.orgTokens(orgId),
    queryFn: async ({ signal }) =>
      (await api.GET('/orgs/{orgId}/tokens', { params: { path: { orgId } }, signal })).data?.items ?? [],
    staleTime: 15_000,
  })
